import BOOLEAN_OPTIONS from '@/helpers/options/boolean';

export const input = {
  callback: null,
  data: {},
  editing: false,
  errors: [],
  mask: {},
  processing: false,
  skip: false,
  type: 'input',
  validated: null,
  validable: false,
  validations: [{
    type: 'blank',
  }],
  value: undefined,
  size: 1,
};

export const select = {
  ...input,
  options: [],
  type: 'select',
};

export const boolean = {
  ...input,
  type: 'boolean',
  options: BOOLEAN_OPTIONS,
};

export const file = {
  ...input,
  type: 'file',
  size: 2,
  meta: {
    type: '',
  },
};
